<template>
	<div class="hero-image">
		<slot>
			<picture>
				<source
					v-if="item.imagePortraitWebp"
					:srcset="item.imagePortraitWebp"
					type="image/webp"
					media="(max-width: 500px)"
				/>
				<source v-if="item.imagePortrait" :srcset="item.imagePortrait" media="(max-width: 500px)" />
				<source :srcset="item.imageWebp" type="image/webp" />
				<source :srcset="item.image" />
				<img class="object-fit" :src="item.image" :alt="item.imageAlt" />
			</picture>
		</slot>
	</div>
</template>

<script setup>
defineProps({
	item: {
		type: Object,
		default: () => {},
	},
	type: {
		type: String,
		default: '',
	},
});
</script>

<style lang="scss" scoped>
.hero-image {
	height: 75vh;
	overflow: hidden;

	&.fullscreen {
		height: 100vh;
	}
}
</style>
